export default "__VITE_ASSET__OyKI2Ir2__"